export const getMenuItems = () => {
  // Caso contrário, exibe ambas as opções
  return [
    { key: "1", label: "Hóspedes" },
    { key: "2", label: "Incluir Autorização" },
    { key: "3", label: "Confirmar Reserva" },
    { key: "5", label: "Receber Pagamento MC" },
    {
      key: "6",
      label: "Mudar Status",
      children: [
        {
          key: "6-1",
          label: "Aguardando Hóspedes",
        },
        {
          key: "6-2",
          label: "Aguardando Autorização",
        },
        {
          key: "6-3",
          label: "Aguardando CheckIn",
        },
        {
          key: "6-4",
          label: "Aguardando Pagamento ao Prorietário",
        },
        {
          key: "6-5",
          label: "Aguardando Pagamento MC",
        },

        {
          key: "6-6",
          label: "Cancelar Reserva",
        },
        {
          key: "6-7",
          label: "Finalizado",
        },
      ],
    },
    { key: "7", label: "Pagar Proprietário" },
  ];
};
